"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./VidyardModal.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
let VidyardEmbed;
if (typeof window !== "undefined") {
  VidyardEmbed = require("@vidyard/embed-code");
}
class VidyardModal extends _react.Component {
  constructor() {
    super();
  }
  componentDidMount() {
    if (typeof window !== "undefined") {
      this.renderVideo();
    }
  }
  componentWillUnmount() {
    if (typeof window !== "undefined") {
      this.removeVideo();
    }
  }
  componentDidUpdate(prevProps) {
    if (typeof window !== "undefined") {
      if (this?.props?.videoProgress !== prevProps?.videoProgress) {
        this.registerProgressEvents(VidyardEmbed);
      }
    }
  }
  registerProgressEvents(VidyardEmbed) {
    if (typeof window !== "undefined" && VidyardEmbed) {
      let paused = true;
      VidyardEmbed?.api?.progressEvents(_ref => {
        let {
          chapter,
          event,
          player
        } = _ref;
        const {
          name
        } = player.metadata.chapters_attributes[chapter].video_attributes;
        this?.props?.setVideoProgress({
          playedPercentage: event,
          id: player?.uuid,
          name: player?.metadata?.name,
          video_action: "on-going",
          videoProvider: "vidyard",
          type: this.props?.type,
          title: this.props.video.videoTitle
        });
      }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100]);
    }
  }
  renderVideo = () => {
    if (typeof window !== "undefined" && VidyardEmbed) {
      VidyardEmbed?.api?.renderDOMPlayers();
      this.registerProgressEvents(VidyardEmbed);
      setTimeout(() => {
        this.registerProgressEvents(VidyardEmbed);
      }, 1000);
    }
  };
  removeVideo = () => {
    if (typeof window !== "undefined") {
      if (typeof document !== "undefined") {
        const video = document.querySelector(".vidyard-player-container");
        if (video) {
          video.remove();
        }
      }
    }
  };
  render() {
    const {
      video
    } = this.props;
    if (typeof window !== "undefined") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "luna-vidyard-modal"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "vidyard-player-embed",
        src: `https://play.vidyard.com/${video?.uuid}.jpg`,
        "data-uuid": video?.uuid,
        "data-v": "4",
        "data-type": "inline",
        alt: "vidyard thumbnail"
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  }
}
var _default = VidyardModal;
exports.default = _default;